import React from 'react'

import POInformationOutlet from '@/components/views/ci/PO/POInformationOutlet'

const PO_POInformationOutlet = () => {
    return <POInformationOutlet />
}

export default PO_POInformationOutlet
